<ng-template #content>
  <tidy-wrapper
    [class]="isRightSideContent ? '' : 'vertical-center hasnt-top-nav'">
    <tidy-card>
      @if (loaded) {
        @if (!isRightSideContent) {
          <tidy-row [align]="'center'">
            <tidy-text [title]="'Confirm'" />
          </tidy-row>
        }
        @if (!address?.address_name) {
          <tidy-row [align]="'center'">
            <tidy-text [header]="'For'" /><span>&nbsp;</span>
            <tidy-text [header]="address?.address1" [translate]="false" />
            <tidy-text
              [header]="address?.address2 !== null ? ' ' + address?.address2 : ''"
              [translate]="false" />
          </tidy-row>
        }
        @if (address?.address_name) {
          <tidy-row [align]="'center'">
            <tidy-text [header]="'For'" /><span>&nbsp;</span>
            <tidy-text [header]="address?.address_name" [translate]="false" />
          </tidy-row>
        }
        @if (viewData?.proName) {
          <tidy-row
            [align]="'center'"
            class="extra-bottom-padding">
            <tidy-text [header]="'Booking with'" /><span>&nbsp;</span>
            <tidy-text [header]="viewData?.proName" [translate]="false" />
          </tidy-row>
        }
        <tidy-row class="vertical-align-center extra-top-padding">
          <tidy-image [src]="'assets/svg/time-outline.svg'" class="body-size" />
          <tidy-text [body]="viewData?.service | titlecase" />
        </tidy-row>
        <!-- <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/svg/refresh-circle-outline.svg'"
          class="body-size">
        </tidy-image>
        <tidy-text
          [body]="viewData?.frequency">
        </tidy-text>
      </tidy-row> -->
      <ng-container>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/calendar-outline.svg'"
            class="body-size" />
          <tidy-text [body]="viewData?.duration" />
        </tidy-row>
      </ng-container>
      <tidy-row class="vertical-align-center">
        <tidy-image [src]="'assets/svg/card-outline.svg'" class="body-size" />
        <tidy-text [body]="'Total:'" /><span>&nbsp;</span>
        <tidy-text [body]="viewData?.price | tcurrency" />
      </tidy-row>
      <!-- <tidy-row *ngIf="!selectedPrivatePro && priceExperiment == 'showCrossedOutDiscount' && viewData?.frequency !== 'One Time'">
      <tidy-text
        [body]="'*Saving 20% with recurring plan'">
      </tidy-text>
    </tidy-row>
    <tidy-row *ngIf="!selectedPrivatePro && isUpdatingSubscription">
      <tidy-text
        [body]="'*' + (viewData?.price | tcurrency)">
        </tidy-text><span>&nbsp;</span>
        <tidy-text
          [body]="'for job (saving 20%)'">
        </tidy-text><br>
        <tidy-text
          [body]="currentSubscription?.amount | tcurrency">
          </tidy-text><span>&nbsp;</span>
          <tidy-text
            [body]="'for'">
            </tidy-text><span>&nbsp;</span>
            <tidy-text
              [body]="me.getSubscriptionType(currentSubscription?.key)">
            </tidy-text>
            <tidy-text
              [body]="'remove'"
              class="link"
              (action)="updateSubscription()">
            </tidy-text>
          </tidy-row> -->
          <!-- <tidy-row *ngIf="!viewData?.service?.includes('hour')" class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/time-outline.svg'"
            class="body-size">
          </tidy-image>
          <ng-container *ngIf="viewData?.billingType == 'hourly'">
            <tidy-text
              [body]="'Minimum'">
              </tidy-text><span>&nbsp;</span>
              <tidy-text
                [body]="viewData?.duration | duration">
              </tidy-text>
            </ng-container>
            <tidy-text
              *ngIf="viewData?.billingType !== 'hourly'"
              [body]="viewData?.duration | duration">
            </tidy-text>
          </tidy-row> -->
        }

        @if (loaded && alreadyAccepted) {
          <tidy-alert>
            <tidy-row>
              <tidy-text [body]="'Quote already accepted — we\'ll confirm with your pro and follow up soon.'" />
            </tidy-row>
          </tidy-alert>
        }

        @if (loaded) {
          <tidy-two-column-row>
            <tidy-button
              [text]="'Go Back'"
              [action]="boundGoBack"
              class="secondary"
              style="justify-content: flex-start; display: flex;" />
            <tidy-button
              [text]="'Confirm'"
              [action]="boundConfirmBooking"
              [disabled]="submitted || alreadyAccepted"
              class="primary"
              style="justify-content: flex-end; display: flex;" />
          </tidy-two-column-row>
        }
      </tidy-card>
    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
